<template>
  <div class="b">
    <Nav :current="current"></Nav>
     <div class="titleBox">基础信息</div>
    <div class="seatch">
      <div>
        <div>导入时间</div>
          <el-date-picker
            v-model="startTimeStr"
            type="datetime"
            :size="inputSize"
            value-format="yyyy-MM-dd hh:mm:ss"
            @change="selectStartTime"
            placeholder="开始日期" style="width: 200px">
          </el-date-picker>
          <el-date-picker
            v-model="endTimeStr"
            type="datetime"
            :size="inputSize"
            value-format="yyyy-MM-dd hh:mm:ss"
            @change="selectEndTime"
            placeholder="结束日期" style="width: 200px">
          </el-date-picker>
      </div>
      <div style="margin:0;">
         <span>状态:</span>
        <select @change="changeProduct($event)">
          <option></option>
          <option
            v-for="(item, index) in selectList"
            :key="index"
            :value="item.id"
          >
            {{ item.name }}
          </option>
        </select>
      </div>
       <div><span>操作者编号:</span> <input type="text" class="searchText" v-model="name" /><span class="el-icon-search" @click="getHistoryList"></span></div>
    </div>
    <div class="el-table-box">
      <el-table
        :data="tableData"
        style="width: 100%; margin-top: 10px; text-align: center"
      >
        <!--          :max-height="tableHeight?tableHeight:0"-->
        <el-table-column
          :prop="col.prop"
          :label="col.label"
          :fixed="col.fixed"
          :width="col.width"
          :type="col.type"
          :min-width="col.minwidth"
          v-for="(col, index) in history"
          :key="index"
        >
        </el-table-column>
      </el-table>

      <div style="margin: 20px 0 80px 0; text-align: center">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next,jumper"
          :total="total"
          :current-page="currentPage"
          :page-sizes="[10, 30, 50, 70, 100]"
          :page-size="pageSize"
          @size-change="changePageSize"
          @current-change="changeCurrentSize"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import Nav from "@/components/Nav.vue";
import apiData from "@/config/api";
import http from "@/config/httpConfig";
export default {
  components: {
    Nav,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      current:'我的公司',
      inputSize:"medium",
      tableHeight: 50,
      currentPage: 1,
      pageSize: 10,
      total: 10,
      selectList: [
        {id:1,name:'导入'},
        {id:2,name:'导出'},
      ],
      tableData: [], //列表数据
      emptyText: "",
      startTimeStr:'',
      endTimeStr:'',
      statusId:'',
      name:'',
      //表格高度
      history: [
        {
          prop: "createdAt",
          label: "导入时间",
          minwidth: "150",
        },
         {
          prop: "filePath",
          label: "文件路径",
          minwidth: "300",
        },
      
         {
          prop: "status",
          label: "状态",
          minwidth: "140",
        },
         {
          prop: "rowCount",
          label: "条数",
          minwidth: "240",
        },
         {
          prop: "userMobile",
          label: "操作者登录手机号",
          minwidth: "240",
        },
         {
          prop: "switchboardIdentityName",
          label: "操作者编号",
          minwidth: "240",
        },
      ],
    };
  },
  mounted() {
    this.getHistoryList();
  },
  methods: {
    //
     changeProduct(event) {
      this.statusId = event.target.value; //获取option对应的value值
      console.log(this.statusId)
    },
    selectStartTime(val){
      this.startTimeStr = val
      console.log(this.startTimeStr)
    },
    selectEndTime(val){
      this.endTimeStr = val
      console.log(this.endTimeStr)
    },

    changePageSize(val) {
      this.pageSize = val;
      this.getHistoryList();
    }, 
    changeCurrentSize(val) {
      this.currentPage = val;
      this.getHistoryList();
    },

    getHistoryList() {
      let _this = this;
      let params = {
        pageNum: _this.currentPage,
        pageSize: _this.pageSize,
        startTimeStr:_this.startTimeStr,
        endTimeStr:_this.endTimeStr,
        status:_this.statusId,
        switchboardIdentityName:_this.name
      };
      this.$nextTick(function () {
        this.clientHeight = `${document.documentElement.clientHeight}`;
        this.tableHeight = 800 + "px";
        http.get(apiData.historyList, true, params, (res) => {
          if (res.data.code == 200) {
            console.log(res.data.data)
            _this.tableData = res.data.data.list;
            _this.startTimeStr = res.data.data.startTimeStr
            _this.endTimeStr = res.data.data.endTimeStr
            _this.total = res.data.data.totalRow;
            for (let i = 0; i < _this.tableData.length; i++) {
              if (_this.tableData[i].status == 1) {
                   _this.tableData[i].status = "导入";
              }else{
                _this.tableData[i].status = "导出";
              }
              
            }
            //  _this.$message.success(res.data.msg);
          } else {
            _this.$message.error(res.data.msg);
          }
        });
      });
    },
  },
};
</script>
<style slot-scope lang="less">
.b {
  margin: 0 10px;
}
.titleBox {
  margin: 20px auto;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  color: #333;
  .txt {
    display: inline-block;
    margin-right: 10px;
  }
}
.zitiyangshi {
  color: #5dc5b8;
  background: red;
}
.seatch-name {
  text-align: left;
  display: flex;
  input {
    width: 120px;
    height: 30px;
    padding-left: 5px;
    margin-left: 5px;
  }
  .el-icon-search {
    font-size: 20px;
    display: block;
    padding: 5px 0 0 5px;
  }
}
.searchText{
  margin-right: 15px;
}
.zitiyaoshi {
  color: #5dc5b8;
}
.el-table-column {
  color: #5dc5b8;
  background: red;
}
.blue {
  color: #5dc5b8;
}
.seatch {
  width: 100%;
  height: 30px;
  div {
    float: left;
    margin-right: 10px;
  }
  input {
    width: 120px;
    height: 30px;
    padding-left: 5px;
    margin-left: 5px;
  }
  select {
    width: 120px;
    height: 30px;
    margin-left: 5px;
    margin-right: 10px;
  }
.el-icon-search {
    font-size: 20px;
    margin-top: 6px;
  }
  .el-form-item{
    width: 300px;
  }
  .el-input--medium .el-input__inner{
    width: 100%;
    height: 30px;
  }
  .el-input--medium .el-input__icon {
    line-height: 30px;
  }

}
</style>